import axios from "axios";

const ENV_URL = process.env.REACT_APP_API_END_POINT;

// Requests for Reponses

export async function getReponseById(id) {
    const res = await axios.get(`${ENV_URL}reponses/${id}`);
    return res.data;
}

export async function updateUserSession({
    session_id,
    question_id,
    reponse_id,
    page,
    custom_reponse_contenu = null,
    formatted_question_contenu = null,
    formatted_question_contenu_en = null
}) {
    const payload = {
        session_id,
        question_id,
        reponse_id,
        page,
        custom_reponse_contenu,
        formatted_question_contenu,
        formatted_question_contenu_en
    };

    console.log("POST /session/reponse/create", payload);

    const res = await axios.post(`${ENV_URL}session/reponse/create`, payload);
    return res.data;
}

export async function updateReponse(body) {
    await axios.post(`${ENV_URL}reponses/update`, body);
}

export async function switchOrderReponse(body) {
    await axios.post(`${ENV_URL}reponses/switch_order`, body);
}

export async function cloneReponse(body) {
    await axios.post(`${ENV_URL}reponses/clone`, body);
}

export async function changeTypeReponse(body) {
    await axios.post(`${ENV_URL}reponses/change_type`, body);
}

export async function deleteReponse(body) {
    await axios.post(`${ENV_URL}reponses/delete`, body);
}

export async function createReponse(body) {
    await axios.post(`${ENV_URL}reponses/create`, body);
}

export async function createQuestionReponseChiaine(body) {
    await axios.post(`${ENV_URL}reponses_chaines/create`, body);
}

export async function getReponsesChaine(id) {
    const res = await axios.get(`${ENV_URL}reponses_chaines/${id}`);
    return res.data;
}

// Requests for Questions

export async function getAllQuestions() {
    const res = await axios.get(`${ENV_URL}questions`);
    return res.data;
}

export async function getQuestionById(id) {
    const res = await axios.get(`${ENV_URL}questions/nomodel/${id}`);
    return res.data;
}

export async function getQuestionSuivateByQuestionId(id) {
    const res = await axios.get(`${ENV_URL}questions/${id}/suivante`);
    return res.data;
}

export async function updateQuestion(body) {
    await axios.post(`${ENV_URL}questions/update`, body);
}

export async function deleteQuestion(id) {
    await axios.delete(`${ENV_URL}questions/delete/${id}`);
}

export async function createQuestion(body) {
    const res = await axios.post(`${ENV_URL}questions/create`, body);
    return res.data;
}

// Requests for Capsules

export async function getAllCapsules() {
    const res = await axios.get(`${ENV_URL}videos`);
    return res.data;
}

export async function updateCapsule(body) {
    await axios.post(`${ENV_URL}videos/update`, body);
}

export async function deleteCapsuleById(id) {
    await axios.delete(`${ENV_URL}videos/${id}`);
}

export async function createCapsule(body) {
    await axios.post(`${ENV_URL}videos/create`, body);
}

export async function switchOrderCapsule(body) {
    await axios.post(`${ENV_URL}videos/switch_order`, body);
}

// Requests for Strategies

export async function getStrategyById(id) {
    const res = await axios.get(`${ENV_URL}strategies/${id}`);
    return res.data;
}

export async function deleteStrategyById(id) {
    await axios.delete(`${ENV_URL}strategies/${id}/delete`);
}

export async function updateStrategy(body) {
    await axios.post(`${ENV_URL}strategies/update`, body);
}

export async function createStrategyByReponseId(body, id) {
    await axios.post(`${ENV_URL}reponses/${id}/strategies/create`, body);
}

export async function checkIfStrategyByReponseId(id) {
    const res = await axios.get(`${ENV_URL}reponses/${id}/strategies/has`);
    return res.data;
}

export async function addStrategyByReponseId(body, id) {
    await axios.post(`${ENV_URL}reponses/${id}/strategies/add`, body);
}

// Requests for Sessions

export async function getAllSessions() {
    const res = await axios.get(`${ENV_URL}sessions`);
    return res.data;
}

export async function updateSessionFavorite(session_id, bool) {
    await axios.put(`${ENV_URL}sessions/${session_id}/favoris?favoris=${bool}`);
}

export async function getSessionReponses(session_id) {
    const res = await axios.get(`${ENV_URL}sessions/${session_id}/reponses`);
    return res.data;
}

export async function createUserSession(body) {
    const res = await axios.post(`${ENV_URL}session/create`, body);
    return res.data.session_id;
}

export async function endUserSession(session_id) {
    await axios.get(`${ENV_URL}sessions/${session_id}/end`);
}

export async function changeUserSessionStatus(session_id, body) {
    await axios.put(`${ENV_URL}sessions/${session_id}/status`, body);
}

export async function deleteUserSession(session_id) {
    await axios.delete(`${ENV_URL}sessions/${session_id}`);
}

// Requests for Historique

export async function getUserHistorique(user_id, limit) {
    const res = await axios.get(`${ENV_URL}historique/${user_id}?order=desc&limit=${limit}`);
    return res.data;
}

export async function getUserHistoriqueFavoris(user_id) {
    const res = await axios.get(`${ENV_URL}historique/${user_id}/favoris`);
    return res.data;
}
